import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Pencil, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export const LeaseTermsDialog = ({ vehicle, el, onSaved }) => {
    const [open, setOpen] = useState(false);
    const [endDate, setEndDate] = useState(vehicle.contract_end_date || '');
    const [kmLimit, setKmLimit] = useState(vehicle.km_limit || '');
    const [saving, setSaving] = useState(false);

    const save = async () => {
        setSaving(true);
        try {
            await api.put(`/leasing/vehicles/${vehicle.id}`, { contract_end_date: endDate || null, km_limit: kmLimit ? Number(kmLimit) : null });
            toast.success(el ? 'Οι όροι αποθηκεύτηκαν' : 'Terms saved');
            setOpen(false);
            onSaved();
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Error');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Button variant="ghost" size="sm" onClick={() => setOpen(true)} className="text-[#1B7EB5]" data-testid={`leasing-vehicle-edit-${vehicle.id}`}>
                <Pencil className="w-4 h-4" />
            </Button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="bg-white" data-testid="lease-terms-dialog">
                    <DialogHeader>
                        <DialogTitle>{el ? 'Όροι σύμβασης' : 'Contract terms'} - {vehicle.license_plate}</DialogTitle>
                    </DialogHeader>
                    <div className="space-y-4">
                        <div className="space-y-1">
                            <Label>{el ? 'Λήξη σύμβασης' : 'Contract end date'}</Label>
                            <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} data-testid="lease-terms-end-date" />
                        </div>
                        <div className="space-y-1">
                            <Label>{el ? 'Όριο χιλιομέτρων' : 'Km limit'}</Label>
                            <Input type="number" value={kmLimit} onChange={(e) => setKmLimit(e.target.value)} data-testid="lease-terms-km-limit" />
                        </div>
                        <Button onClick={save} disabled={saving} className="w-full bg-[#1B7EB5] hover:bg-[#58A6B4] text-white rounded-sm" data-testid="lease-terms-save">
                            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : (el ? 'Αποθήκευση' : 'Save')}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
